$(document).ready(function () {
  $(".btn-mob-search").on("click", function () {
    $(".mobile-search-wrapper").toggle();
  });
  $(".accordion_header").click(function () {
    const index = $(this).data("index");
    $(".accordion_header").removeClass("ui-state-active");
    $(this).addClass("ui-state-active");
    $(".cstm_content").each(function () {
      if ($(this).data("index") == index) {
        $(this).slideDown("normal");
      } else {
        $(this).slideUp("normal");
      }
    });
  });
  var header_h = $(".site-header-container").height();
  $("body").css("padding-top", header_h);
  var price, compare_price, recharge_price, quantity;
  var price_, compare_price_, recharge_price_;
  $("[data-all-variants] option[selected]").each(function () {
    price = $(this).data("variant-price");
    compare_price = $(this).data("variant-compare-price");
    recharge_price = price * 0.9;
    price_ = $(this).data("variant-price");
    compare_price_ = $(this).data("variant-compare-price");
    recharge_price_ = price_ * 0.9;
    quantity = $(this).data("inventory-quantity");
    if (compare_price > 0) {
      $(this)
        .closest(".product-form")
        .find(".was-price")
        .text("$" + (compare_price / 100).toFixed(2));
    }
  });
  $(window).on("click", function (e) {
    let target = $(e.target);

    if (target.closest(".rc-radio").length > 0) {
      if (target.closest(".rc-radio").hasClass("rc-option__onetime")) {
        if (compare_price > 0) {
          $(".ik-product-price").html(
            '<s data-price-compare="" class="was-price">$' +
              (compare_price / 100).toFixed(2) +
              '</s><span data-price="">$' +
              (price / 100).toFixed(2) +
              "</span>"
          );
        } else {
          $(".ik-product-price").html(
            '<s data-price-compare="" class="was-price" style="display:none;">$' +
              (compare_price / 100).toFixed(2) +
              '</s><span data-price="">$' +
              (price / 100).toFixed(2) +
              "</span>"
          );
        }
      } else {
        if (compare_price > 0) {
          $(".ik-product-price").html(
            '<s data-price-compare="" class="was-price">$' +
              (compare_price / 100).toFixed(2) +
              '</s><span data-price=""><span class="recharge_price">$' +
              (price / 100).toFixed(2) +
              "</span>$" +
              (recharge_price / 100).toFixed(2) +
              "</span>"
          );
        } else {
          $(".ik-product-price").html(
            '<s data-price-compare="" class="was-price" style="display:none;">$' +
              (compare_price / 100).toFixed(2) +
              '</s><span data-price=""><span class="recharge_price">$' +
              (price / 100).toFixed(2) +
              "</span>$" +
              (recharge_price / 100).toFixed(2) +
              "</span>"
          );
        }
      }
    }
  });
  $(".product-main .product-form .e-btn").on("click", function () {
    setTimeout(() => {
      let percent = $(this).closest(".e-controls").find(".e-input").val();
      // if() {
      if ($(".ik-pdp-add-to-cart").hasClass("is_available")) {
        if (percent < 11) {
          $(this)
            .closest(".product-info")
            .find(".discount_num")
            .text(percent + "/10");
          if (percent == 10) {
            $(this)
              .closest(".product-info")
              .find(".progress-complete")
              .css({
                width: percent * 10 + "%",
                "border-radius": "5px",
                "background-color": "#00B418",
              });
            $(this).closest(".product-info").addClass("complete");
            price = price_ * 0.85;
            // compare_price = compare_price_ * percent;
            recharge_price = recharge_price_ * 0.85;
          } else {
            $(this)
              .closest(".product-info")
              .find(".progress-complete")
              .css({
                width: percent * 10 + "%",
                "border-radius": "5px 0 0 5px",
                "background-color": "#b82325",
              });
            $(this).closest(".product-info").removeClass("complete");
            price = price_;
            compare_price = compare_price_;
            recharge_price = recharge_price_;
          }
        } else {
          price = price_ * 0.85;
          compare_price = compare_price_;
          recharge_price = recharge_price_ * 0.85;
        }
        if ($(".ik-product-price").find(".recharge_price").length > 0) {
          if (compare_price > 0) {
            $(".ik-product-price").html(
              '<s data-price-compare="" class="was-price">$' +
                (compare_price / 100).toFixed(2) +
                '</s><span data-price=""><span class="recharge_price">$' +
                (price / 100).toFixed(2) +
                "</span>$" +
                (recharge_price / 100).toFixed(2) +
                "</span>"
            );
          } else {
            $(".ik-product-price").html(
              '<s data-price-compare="" class="was-price" style="display:none;">$' +
                (compare_price / 100).toFixed(2) +
                '</s><span data-price=""><span class="recharge_price">$' +
                (price / 100).toFixed(2) +
                "</span>$" +
                (recharge_price / 100).toFixed(2) +
                "</span>"
            );
          }
        } else {
          if (compare_price > 0) {
            $(".ik-product-price").html(
              '<s data-price-compare="" class="was-price">$' +
                (compare_price / 100).toFixed(2) +
                '</s><span data-price="">$' +
                (price / 100).toFixed(2) +
                "</span>"
            );
          } else {
            $(".ik-product-price").html(
              '<s data-price-compare="" class="was-price" style="display: none;">$' +
                (compare_price / 100).toFixed(2) +
                '</s><span data-price="">$' +
                (price / 100).toFixed(2) +
                "</span>"
            );
          }
        }
        $(".inventory_status").removeClass("active");
      } else {
        var selectedVariantName = $('select[name="product-option-flavour"] :selected').val();
        var selectedVariantNameQuant = $('[data-option1="'+selectedVariantName+'"]').attr("data-inventory-quantity");
        selectedVariantNameQuant = Number(selectedVariantNameQuant);
        if(percent>selectedVariantNameQuant){
          $(this).closest(".e-controls").find(".e-input").val(percent - 1);
          $(".inventory_status").addClass("active");
        }
        else{
          if (percent < 11) {
            $(this)
              .closest(".product-info")
              .find(".discount_num")
              .text(percent + "/10");
            if (percent == 10) {
              $(this)
                .closest(".product-info")
                .find(".progress-complete")
                .css({
                  width: percent * 10 + "%",
                  "border-radius": "5px",
                  "background-color": "#00B418",
                });
              $(this).closest(".product-info").addClass("complete");
              price = price_ * 0.85;
              // compare_price = compare_price_ * percent;
              recharge_price = recharge_price_ * 0.85;
            } else {
              $(this)
                .closest(".product-info")
                .find(".progress-complete")
                .css({
                  width: percent * 10 + "%",
                  "border-radius": "5px 0 0 5px",
                  "background-color": "#b82325",
                });
              $(this).closest(".product-info").removeClass("complete");
              price = price_;
              compare_price = compare_price_;
              recharge_price = recharge_price_;
            }
          } else {
            price = price_ * 0.85;
            compare_price = compare_price_;
            recharge_price = recharge_price_ * 0.85;
          }
          if ($(".ik-product-price").find(".recharge_price").length > 0) {
            if (compare_price > 0) {
              $(".ik-product-price").html(
                '<s data-price-compare="" class="was-price">$' +
                  (compare_price / 100).toFixed(2) +
                  '</s><span data-price=""><span class="recharge_price">$' +
                  (price / 100).toFixed(2) +
                  "</span>$" +
                  (recharge_price / 100).toFixed(2) +
                  "</span>"
              );
            } else {
              $(".ik-product-price").html(
                '<s data-price-compare="" class="was-price" style="display:none;">$' +
                  (compare_price / 100).toFixed(2) +
                  '</s><span data-price=""><span class="recharge_price">$' +
                  (price / 100).toFixed(2) +
                  "</span>$" +
                  (recharge_price / 100).toFixed(2) +
                  "</span>"
              );
            }
          } else {
            if (compare_price > 0) {
              $(".ik-product-price").html(
                '<s data-price-compare="" class="was-price">$' +
                  (compare_price / 100).toFixed(2) +
                  '</s><span data-price="">$' +
                  (price / 100).toFixed(2) +
                  "</span>"
              );
            } else {
              $(".ik-product-price").html(
                '<s data-price-compare="" class="was-price" style="display: none;">$' +
                  (compare_price / 100).toFixed(2) +
                  '</s><span data-price="">$' +
                  (price / 100).toFixed(2) +
                  "</span>"
              );
            }
          }
          $(".inventory_status").removeClass("active");
        }
      }
    }, 100);
  });
  
  if($(window).width() > 767) {
    $(".img_content").mousemove(function (event) {
      $(this)
        .find(".magnigfy_img")
        .css("left", $(this).width() +180 - event.pageX)
        .css("display", "block")
        .css("top", $(this).height() + 240 - event.pageY);
    });
    $(".img_content").mouseleave(function (event) {
      $(this)
        .find(".magnigfy_img")
        .css("display", "none");

    });
  }
  

  // setTimeout(function(){
  //   $('[data-minicart-qty-selector]').each(function(){
  //     var item_id = $(this).data('variant-id');
  //     var inventory;
  //     CartJS.cart.items.forEach(function (item) {
  //       if(item_id == item.id) {
  //         inventory = item.properties.inventory;
  //       }
  //     })
  //     $(this).attr('data-inventory', inventory)
  //   });
  //   $('[data-minicart-qty-selector]').find('.m-incr').on('click', function(){
  //     setTimeout(() => {
  //       $(this).attr('disabled','');
  //       console.log('click here')
  //       console.log($(this).closest('[data-minicart-qty-selector]').data('inventory'))
  //       if($(this).closest('[data-minicart-qty-selector]').data('inventory') == $(this).closest('[data-minicart-qty-selector]').find('.e-input').val() || $(this).closest('[data-minicart-qty-selector]').data('inventory') < $(this).closest('[data-minicart-qty-selector]').find('.e-input').val() ) {
  //         $(this).closest('[data-minicart-qty-selector]').find('.m-decr').click();
  //       }
  //     }, 1000);

  //   })
  // }, 1000)
});

$(window).resize(function () {
  var header_h = $(".site-header-container").height();
  $("body").css("padding-top", header_h);
});
$(window).on("click", function (e) {
  var $target = $(e.target);
  if ($target.closest(".m-decr").length > 0) {
    if ($target.next().val() == 1) {
      $target
        .closest(".minicart__item")
        .find("[data-remove-from-cart]")
        .click();
    }
  }
});

// function debounce(func, timeout = 300){
//   let timer;
//       return (...args) => {
//       clearTimeout(timer);
//       timer = setTimeout(() => { func.apply(this, args); }, timeout);
//   };
// }

$(".search-form")
  .find(".input")
  .on("keyup", function () {
    if ($(this).val() != "") {
      $(".search-form").find("button").hide();
    } else {
      $(".search-form").find("button").show();
    }
  });
// document.querySelector('input.input').addEventListener('input', debounce((event) => {
//   search($('.search-form').find('.input').val());
// }, 300).bind(this));
// var resultsList = $('.searchResult');
// var shopURL = $('body').data('shop-url');
// var searchPath = shopURL + '/search?type=product&q=';
// var search = function(searchItem) {
//   var cleanTerm = encodeURI(searchItem);
//   var searchURL =  searchPath + cleanTerm;
//   console.log(searchURL)

//   fetch(searchURL)
//   .then((response) => {
//     if (!response.ok) {
//       var error = new Error(response.status);
//       this.close();
//       throw error;
//     }

//     return response.text();
//   })
//   .then((text) => {
//     // console.log(text)

//     if(new DOMParser().parseFromString(text, 'text/html').querySelector('.products-grid') != null) {
//       const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('.products-grid').innerHTML;
//       $('.searchResult').html(resultsMarkup);
//     } else {
//       $('.searchResult').html('');
//     }

//   })
//   .catch((error) => {
//     this.close();
//     throw error;
//   });

//   // $.getJSON(searchURL +'*&view=json', function(data) {
//   //   console.log('result end')
//   //   console.log(data);
//   //   resultsList.empty();
//   //   if(data.results_count == 0) {

//   //   }
//   // })
// }

$("[accordion_header]").on("click", function () {
  const id = $(this).data("id");
  const isActive = $(this).hasClass("active");

  $("[accordion_header]").each(function () {
    if ($(this).data("id") !== id || isActive) {
      $(this).removeClass("active");
    }
  });

  $("[accordion_header]")
    .parent()
    .parent()
    .parent()
    .find(".accordion_content .nav__items")
    .each(function () {
      if ($(this).data("id") !== id || isActive) {
        $(this).removeClass("active");
      } else {
        $(this).addClass("active");
      }
    });

  !isActive && $(this).addClass("active");
});

$(".read_more").on("click", function () {
  $(".read_more_content").addClass("active");

  $(".read_less").show();
  $(this).hide();
});
$(".read_less").on("click", function () {
  $(".read_more_content").removeClass("active");

  $(".read_more").show();
  $(this).hide();
});

$("[spel_link]").on("click", function () {
  var spel = $(this).text().toLowerCase();
  $("[spel_link]").each(function () {
    $(this).removeClass("active");
  });
  $(this).addClass("active");
  $("[spel]").each(function () {
    var com_spel = $(this).text().slice(0, 1).toLowerCase();
    if (spel == "all") {
      $(this).parent().show();
    } else {
      if (spel == com_spel) {
        $(this).parent().show();
      } else {
        $(this).parent().hide();
      }
    }
  });
});

$(".nav__link.m-level-1[data-accordion-button]").click(function (e) {
  e.preventDefault();
  if ($(this)?.attr("href") != "") location.href = $(this).attr("href");
});

$(".search-form.search-form-mobile .cstm_searchheader").click(function (e) {
  e.preventDefault();

  $(".site-nav--mobile .search-button, .js-search-destop");
  window.BoostPFS.openSuggestionMobile();
  // const $searchPopup = $(".mobile-search-popup");
  // const isActive = $searchPopup.hasClass("active");

  // if (!isActive) {
  // 	$searchPopup.addClass("active");
  // } else {
  // 	$searchPopup.removeClass("active");
  // 	$(".boost-pfs-search-suggestion-open").removeClass(
  //     "boost-pfs-search-suggestion-open"
  //   );
  // }
});

$(".mobile-search-popup .back-button").click((e) =>
  $(".mobile-search-popup").removeClass("active")
);

// $(".ik-qty-input").change(function() {
//   $(".ik-qty-input").attr('value', $(".ik-qty-input").val());
// });

// $('[name="product-option-size"]').change(function() {
//   var selectedSize = $(this).val();
//   var variantPrice = $("#addToCartForm select[name='all-variants']").find("option[data-option1='"+ selectedSize +"']").attr('data-variant-price') / 100;
//   $(".ik-product-price span[data-price]").html("$" + variantPrice);
// });

function customResize() {
  const $searchPopup = $(".mobile-search-popup");
  const isPopupActive = $searchPopup.hasClass("active");
  if (isPopupActive && window.document.width > 768) {
    $searchPopup.removeClass("active");
    $(".boost-pfs-search-suggestion-open").removeClass(
      "boost-pfs-search-suggestion-open"
    );
  }

  const navbarHeight = $(".site-header .ik-menu-wrap").height();

  $(".nav-dropdown").css({
    top: `calc(100% - ${navbarHeight + 5}px)`,
  });
}

$(document).ready(customResize);
$(window).resize(customResize);

// document.addEventListener('rebuy.add', function(event){ console.log('rebuy.add event', event.detail); }); 
// document.addEventListener('rebuy.change', function(event){ console.log('rebuy.change event', event.detail); }); 
// document.addEventListener('rebuy:cart.add', function(event){ console.log('rebuy:cart.add event', event.detail); }); 
document.addEventListener('rebuy:cart.change', function(event){ 
  var itemCount = event.detail.cart.cart.item_count;
  $(".cart-item__count[data-cart-count]").text(itemCount);
}); 